import type { Manifest } from '@/types/manifest';
import { ManifestCard } from './manifest-card';

interface ManifestListProps {
  manifests: Manifest[];
  isLoading: boolean;
  error: string | null;
}

export function ManifestList({ manifests, isLoading, error }: ManifestListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-gray-800 rounded-lg p-6 animate-pulse">
            <div className="h-6 bg-gray-700 rounded w-3/4 mb-2" />
            <div className="h-4 bg-gray-700 rounded w-1/2 mb-4" />
            <div className="h-2.5 bg-gray-700 rounded w-full" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded">
        {error}
      </div>
    );
  }

  if (manifests.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-800 rounded-lg">
        <p className="text-gray-400">No manifests found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {manifests.map((manifest) => (
        <ManifestCard key={manifest.id} manifest={manifest} />
      ))}
    </div>
  );
}
